import {
  RedisSolicitacaoListParams,
  RedisSolicitacaoListResponse,
} from "@/models/auction-redis.model";
import { axiosLeilaoConsignadoTrabalhadorInstance } from "./axiosInstance";

const USE_MOCK_AUCTION_PROPOSALS =
  import.meta.env.VITE_USE_AUCTION_MOCKS === "true";

/**
 * Lista, paginadas, as solicitações de leilão que ainda vivem no Redis —
 * antes de virarem `PropostaLeilao` no Postgres. Endpoint de acompanhamento
 * em tempo real do ciclo de vida do lote/lance.
 *
 * Endpoint: GET /api-consignado-trabalhador/v1/proposta-leilao/redis
 *
 * Query params (snake_case no wire):
 *  - pagina, tamanho_pagina
 *  - status (CSV: WAITING_BID,BID_SENT,WON,REPROVED,SENT_TO_DATAPREV,INCLUDED_DATAPREV)
 *  - codigo_lote
 *  - search_term (CPF ou número da solicitação)
 *
 * Disponível na branch `feat/leilao-v2` do backend; até o merge na develop,
 * fica atrás do flag `VITE_USE_AUCTION_MOCKS`.
 */
export async function getAuctionRedisSolicitacoes(
  params: RedisSolicitacaoListParams,
): Promise<RedisSolicitacaoListResponse> {
  if (USE_MOCK_AUCTION_PROPOSALS) {
    const { getMockAuctionRedisSolicitacoes } = await import(
      "@/mocks/auctionRedis.mock"
    );
    return getMockAuctionRedisSolicitacoes(params);
  }

  const queryParams = new URLSearchParams();
  queryParams.set("pagina", String(params.page));
  queryParams.set("tamanho_pagina", String(params.pageSize));

  if (params.statuses?.length) {
    queryParams.set("status", params.statuses.join(","));
  }

  const codigoLote = params.codigoLote?.trim();
  if (codigoLote) {
    queryParams.set("codigo_lote", codigoLote);
  }

  const searchTerm = params.searchTerm?.trim();
  if (searchTerm) {
    queryParams.set("search_term", searchTerm);
  }

  const { data } =
    await axiosLeilaoConsignadoTrabalhadorInstance.get<RedisSolicitacaoListResponse>(
      "/api-consignado-trabalhador/v1/proposta-leilao/redis",
      { params: queryParams },
    );

  return data;
}
